import React, { useEffect, useState, createContext } from 'react';
import PropTypes from 'prop-types';
import { useSession, Loading } from '@cordata/buffet';

import * as NS from './instances';

const ApiContext = createContext();

const ApiProvider = ({
  children,
}) => {
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState({});
  const { current } = useSession();

  const namespaces = NS;

  useEffect(() => {
    setLoading(true);

    if (current) {
      const { attributes: { permissions } } = current;

      if (permissions.map(p => p.securityPermissionName).includes('hasAppKickstarter')) {
        setValue({
          namespace: namespaces.adminInstance,
          config: namespaces.referenceAdminInstance,
        });
        setLoading(false);
      } else {
        setValue({
          namespace: namespaces.publicInstance,
          config: namespaces.referenceInstance,
        });
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [current]);

  return (
    <ApiContext.Provider
      value={{
        loading,

        ...value,
        api: value.namespace,
        ns: value.namespace,

        namespaces,
      }}
    >
      {loading ? <Loading /> : children}
    </ApiContext.Provider>
  );
};

ApiProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ApiProvider;
export { ApiContext };

